import React from 'react';
import Navbar from '../Layout/Navbar';
import PublicNavbar from '../Layout/PublicNavbar';
import Footer from '../Layout/Footer';
import { useAuth } from '../../contexts/AuthContext';
import SEO from '../Common/SEO';
import './Legal.css';

function Disclaimer() {
  const { isAuthenticated } = useAuth();
  const updatedDate = 'January 16, 2026';

  return (
    <div className="page-wrapper">
      <SEO
        title="Disclaimer"
        description="Options Tracker Disclaimer - Important information about the educational nature of this service. Not financial advice."
        canonicalPath="/disclaimer"
      />
      {isAuthenticated ? <Navbar /> : <PublicNavbar />}
      <div className="container legal-page">
        <div className="page-header">
          <div>
            <h1>Disclaimer</h1>
            <p className="page-subtitle">Important information about use of this service.</p>
            <div className="legal-updated">Last updated: {updatedDate}</div>
          </div>
        </div>

        <h2>Not Financial Advice</h2>
        <p>
          Options Tracker does not provide financial, investment, tax, or legal advice. All content is for educational
          and informational purposes only.
        </p>

        <h2>Educational & Tracking Use</h2>
        <p>
          The platform is designed to help users record and analyze their own trades. You are responsible for verifying
          the accuracy of your entries and any results.
        </p>

        <h2>Market Data Limitations</h2>
        <p>
          Market data may be delayed, estimated, or sourced from third parties. VIX values may be approximations and
          are not guaranteed to be accurate or real-time.
        </p>

        <h2>No Warranty</h2>
        <p>
          The service is provided “as is” without warranties of any kind. We do not guarantee accuracy, availability,
          or suitability for any purpose.
        </p>

        <h2>Contact</h2>
        <p>
          For questions about this disclaimer, contact
          {' '}
          <a href="mailto:options.tracker.email.verify@gmail.com?subject=Disclaimer">
            options.tracker.email.verify@gmail.com
          </a>
          .
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default Disclaimer;

